<template>
  <div>
    <v-card>
      <v-card-title>
        <div>
          <p class="font-weight-bold mt-0 mb-0 v-das-title-font">MUIC Lecture Full-time List</p>
        </div>
        <v-spacer />
        <v-select v-model="selectedDivision" :items="uniqueDivisions" label="Filter by Division" outlined dense
          hide-details class="mr-4" style="max-width: 300px"></v-select>
        <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details filled dense
          class="mr-4" />
      </v-card-title>
      <!-- table -->
      <v-data-table :headers="headers" :items="filteredUsers" :search="search" item-key="email" :loading="loadselected"
        :items-per-page="50" class="elevation-1" :sort-by="['division']" :sort-desc="[false]">
        <template #item.avatar="{ item }">
          <v-avatar rounded size="36">
            <img :src="'https://my.muic.io/api' +
              item.img
              " />
          </v-avatar>
        </template>
        <template #item.name="{ item }">
          <p class="mt-0 mb-0 font-weight-bold">

            <v-avatar rounded :color="item.status && item.status.name_eng === 'NORMAL' ? `green lighten-1` : `red darken-3`" size="10"
              class="mr-2">
            </v-avatar>

            {{ item.title ? item.title.name_eng : '' }} {{ item.name }} {{ item.surname }} ({{ item.nickname_thai }})
          </p>
          <small>Office phone: {{ item.telephone }}</small>
        </template>
        <template #item.division="{ item }">
          <p class="mt-0 mb-0 font-weight-bold">{{ item.department ? item.department.name_eng : '-' }}</p>
        </template>
        <template #item.email="{ item }">
          <a>
            <p class="mt-0 mb-0 font-weight-bold">{{ item.email }}</p>
          </a>
        </template>
        <template #item.actions="{ item }">
          <div class="d-flex flex-nowrap align-center justify-end">
            <v-btn icon @click="openCreateDialog(item)">
              <v-icon>mdi-folder-arrow-left-outline</v-icon>
            </v-btn>
            <v-btn icon @click="openFormDialog(item)">
              <v-icon>mdi-pencil-plus</v-icon>
            </v-btn>
          </div>
        </template>
        <template #footer.page-text="{ pageStart, pageStop, itemsLength }">
          Showing {{ pageStart }}–{{ pageStop }} of {{ itemsLength }}
        </template>
      </v-data-table>
    </v-card>
    <!-- data -->
    <v-navigation-drawer v-model="createDialog" right temporary fixed width="1200">
      <!-- x -->
      <SheetLecture :selectedLecture="dataUser" :activityLecture="dataReportUser" :totalHour="totalHour"
        :totalPoint="totalPoint" :totalSuccess="totalSuccess" :activityType="activityType"
        :dataReportErrorUser="dataReportErrorUser" @getActivityListYear="dataView" @closeDialogCom="closeDialog">
      </SheetLecture>
    </v-navigation-drawer>

    <v-navigation-drawer v-model="formDialog" right temporary fixed width="1200">
      <SheetForm :selectedLecture="dataUser" :activityType="activityType" @closeDialogCom="closeFormDialog">
      </SheetForm>
    </v-navigation-drawer>

    <v-snackbar v-model="toast" timeout="2500" color="success" top right>
      {{ toastMessage }}
    </v-snackbar>

  </div>
</template>

<script>
import SheetLecture from '@/components/SheetLecture.vue';
import SheetForm from '@/components/SheetForm.vue';
export default {
  name: 'UsersView',
  components: { SheetLecture, SheetForm },
  data: () => ({
    search: '',
    selectedDivision: 'All', // Default to All
    createDialog: false,
    formDialog: false,
    dataUser: {},
    dataReportUser: [],
    dataReportErrorUser: [],
    loadView: false,
    toast: false,
    toastMessage: '',
    headers: [
      { text: '', value: 'avatar', class: "font-weight-bold blue-grey darken-3 white--text", },
      { text: 'Name', value: 'name', class: "font-weight-bold blue-grey darken-3 white--text", },
      { text: 'Division', value: 'division', class: "font-weight-bold blue-grey darken-3 white--text", },
      { text: 'Email', value: 'email', class: "font-weight-bold blue-grey darken-3 white--text", },
      { text: 'Interesting', value: 'lastActive', class: "font-weight-bold blue-grey darken-3 white--text", },
      { text: '', value: 'actions', sortable: false, align: 'end', class: "font-weight-bold blue-grey darken-3 white--text", },
    ],
    users: [],
    activeUser: null,
    loadselected: false,
    page: 1,
    itemsPerPage: 50,

    // activity
    activityType: [],

    // 
    totalHour: 0,
    totalPoint: 0,
    totalSuccess: 0,
  }),
  computed: {
    pageCount() {
      return Math.ceil(this.filteredUsers.length / this.itemsPerPage)
    },
    uniqueDivisions() {
      const divisions = this.users
        .map(u => u.division)
        .filter(d => d && d !== '-');
      return ['All', ...new Set(divisions)].sort();
    },
    filteredUsers() {
      let list = this.users;

      if (this.selectedDivision && this.selectedDivision !== 'All') {
        list = list.filter(u => u.division === this.selectedDivision);
      }

      return list;
    }
  },
  mounted() {
    this.getInstructor()
    this.getActivityType()
  },
  methods: {

    async openCreateDialog(itemAccount) {

      // console.log("muic_account", itemAccount.muic_account)
      this.totalHour = 0;
      this.totalPoint = 0;
      this.totalSuccess = 0;
      this.dataReportUser = []
      this.dataReportErrorUser = []

      try {
        const [resInstructorView, resSecondApi] = await Promise.all([
          this.$http.get(`/academic-service/professor-profiles/?muic_account_aj__username=${itemAccount.muic_account}`),
          this.$http.get(`/academic-service/main-activities/?muic_account_aj__username=${itemAccount.muic_account}`)
        ]);

        if (resInstructorView.status === 200 && resSecondApi.status === 200) {

          // console.log("API1:", resInstructorView.data[0]);
          // console.log("API2:", resSecondApi.data);

          this.createDialog = true;
          this.dataUser = Object.assign({}, itemAccount, resInstructorView.data.length != 0 ? resInstructorView.data[0] : {});
          this.dataReportUser = resSecondApi.data;

          const approvedList = resSecondApi.data.filter(
            (a) => a.status === "approve"
          );

          this.dataReportErrorUser = resSecondApi.data.filter(
            (a) => ['save', 'send', 'reject'].includes(`${a.status}`)
          );


          this.totalHour = approvedList.reduce(
            (sum, cur) => sum + Number(cur.point_activity || 0),
            0
          );
          this.totalPoint = approvedList.reduce(
            (sum, cur) => sum + Number(cur.point_activity || 0),
            0
          );

          this.totalSuccess = approvedList.length;

          // console.log(this.activityType)
          // console.log("API2:", resSecondApi.data);

          this.loadView = '';

        } else {
          throw "API error";
        }

      } catch (error) {
        console.error(error);
        this.dataUser = {};
        this.dataReportUser = [];
        this.loadView = '';
      }

    },

    async getActivityType() {
      this.activityType = [];
      try {
        const resType = await this.$http.get(`/academic-service/activity-types/`);
        if ([200, 201].includes(resType.status)) {
          this.activityType = resType.data.filter((a) => a.status === "on").map((item) => {
            return {
              text: `${item.detail} (x${parseFloat(item.point).toFixed(2)} Point )`,
              value: item.id,
              ...item
            };
          })
        } else {
          throw { resType };
        }
      } catch (error) {
        console.log(error)
      }
    },

    closeDialog() {
      this.createDialog = false
      this.dataUser = Object.assign({}, {})
    },

    async openFormDialog(itemAccount) {
      this.dataUser = Object.assign({}, itemAccount);
      try {
        const resInstructorView = await this.$http.get(`/academic-service/professor-profiles/?muic_account_aj__username=${itemAccount.muic_account}`);
        if (resInstructorView.status === 200 && resInstructorView.data.length !== 0) {
          this.dataUser = Object.assign({}, itemAccount, resInstructorView.data[0]);
        }
      } catch (error) {
        console.error(error);
      }
      this.formDialog = true;
    },

    closeFormDialog() {
      this.formDialog = false
      this.dataUser = Object.assign({}, {})
    },

    saveUser() {
      if (!this.form.name || !this.form.email) {
        this.toastMessage = 'Please complete all fields before saving.'
        this.toast = true
        return
      }
      this.users.unshift({
        ...this.form,
        lastActive: 'Just now',
        status: 'Active',
      })
      this.toastMessage = `${this.form.name} added`
      this.toast = true
      this.closeDialog()
    },
    setActiveUser(user) {
      this.activeUser = user
      this.toastMessage = `${user.name} selected`
      this.toast = true
    },
    // gey user
    async getInstructor() {
      this.users = []
      this.loadselected = true
      try {
        const resInstructor = await this.$http.get(
          `/teaching/contract/lecturer_list/?lecturer_type=full_time`
        );
        if (resInstructor.status === 200) {
          this.users = resInstructor.data.map((item) => {
            return {
              ...item,
              division: item.department ? item.department.name_eng : '-' // Map division for sorting/filtering
            };
          });
          this.loadselected = false;
        } else {
          throw { resInstructor };
        }
      } catch (error) {
        this.users = [];
        this.loadselected = false;
      }
    },


    getPaDateRange(paYearBE) {
      const yearAD = paYearBE - 543
      return {
        start: this.$dayjs(`${yearAD - 1}-07-01`),
        end: this.$dayjs(`${yearAD}-06-30`)
      }
    },

    async dataView(paYearBE) {

      this.totalHour = 0
      this.totalPoint = 0
      this.totalSuccess = 0
      this.dataReportUser = []
      this.dataReportErrorUser = []

      try {
        const res = await this.$http.get(
          `/academic-service/main-activities/?muic_account_aj__username=${this.dataUser.muic_account}`
        )

        if (res.status === 200) {

          // ✅ FILTER ตาม PA (ถ้ามีการเลือกปี)
          const filtered = res.data.filter(a => {
            if (!paYearBE) return true // "ทั้งหมด"
            if (!a.date_end) return false
            const endDate = this.$dayjs(a.date_end)
            const range = this.getPaDateRange(paYearBE)
            return endDate.isSameOrAfter(range.start, 'day') &&
              endDate.isSameOrBefore(range.end, 'day')
          })

          this.dataReportUser = filtered

          const approved = filtered.filter(a => a.status === 'approve')

          this.dataReportErrorUser = filtered.filter(a =>
            ['save', 'send', 'reject'].includes(a.status)
          )

          // ✅ SUMMARY คิดจาก filtered เท่านั้น
          this.totalHour = approved.reduce(
            (sum, cur) => sum + Number(cur.point_activity || 0),
            0
          )

          this.totalPoint = approved.reduce(
            (sum, cur) => sum + Number(cur.point_activity || 0),
            0
          )

          this.totalSuccess = approved.length
        }
      } catch (err) {
        console.error(err)
      }
    }




  },
}
</script>
